module.exports = __webpack_public_path__ + "themes/mf/img/prize-8.png";


//////////////////
// WEBPACK FOOTER
// ./themes/mf/img/prize-8.png
// module id = 100
// module chunks = 3